(function () {
  'use strict';

  // FAQ — jedno pytanie otwarte; home: stała min-height listy (bez przeskoków).
  function stabilizeHomeList(list) {
    if (!list.closest('.cw-home-faq')) {
      return;
    }

    var items = list.querySelectorAll('.cw-home-faq__item');
    if (!items.length) {
      return;
    }

    var states = [];
    var i;

    for (i = 0; i < items.length; i += 1) {
      states[i] = items[i].open;
      items[i].open = false;
    }

    var collapsedHeight = list.offsetHeight;
    var maxExtra = 0;

    for (i = 0; i < items.length; i += 1) {
      items[i].open = true;
      maxExtra = Math.max(maxExtra, list.offsetHeight - collapsedHeight);
      items[i].open = false;
    }

    for (i = 0; i < items.length; i += 1) {
      items[i].open = states[i];
    }

    list.style.minHeight = String(collapsedHeight + maxExtra) + 'px';
  }

  function bindLists() {
    var lists = document.querySelectorAll('.cw-home-faq__list');

    for (var l = 0; l < lists.length; l += 1) {
      stabilizeHomeList(lists[l]);

      var items = lists[l].querySelectorAll('.cw-home-faq__item');
      for (var i = 0; i < items.length; i += 1) {
        items[i].addEventListener('toggle', function () {
          if (!this.open) {
            return;
          }

          var item = this;
          var parent = item.closest('.cw-home-faq__list');
          if (!parent) {
            return;
          }

          var summary = item.querySelector('.cw-home-faq__summary');
          var anchorTop = summary
            ? summary.getBoundingClientRect().top
            : item.getBoundingClientRect().top;

          var siblings = parent.querySelectorAll('.cw-home-faq__item');
          var hadOpenSibling = false;

          for (var s = 0; s < siblings.length; s += 1) {
            if (siblings[s] !== item && siblings[s].open) {
              hadOpenSibling = true;
              siblings[s].open = false;
            }
          }

          if (!hadOpenSibling || !summary) {
            return;
          }

          var anchorTopAfter = summary.getBoundingClientRect().top;
          var delta = anchorTopAfter - anchorTop;

          if (Math.abs(delta) < 0.5) {
            return;
          }

          window.scrollBy(0, delta);
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLists);
  } else {
    bindLists();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var lists = document.querySelectorAll('.cw-home-faq__list');
      for (var i = 0; i < lists.length; i += 1) {
        lists[i].style.minHeight = '';
        stabilizeHomeList(lists[i]);
      }
    }, 150);
  });
})();
